import { Grid2 } from '@mui/material';
import { FunctionComponent } from 'react';
import { CustomerDetailsCard } from '@/pageContents/customers/details/CustomerDetailsCard';
import { Customer } from '@/models/customer';
import { CustomerGroupsCard } from '@/pageContents/customers/details/CustomerGroupsCard';
import { CustomerCreditCard } from '@/pageContents/customers/details/CustomerCreditCard';
import { NotesCard } from '@/pageContents/customers/details/NotesCard';

type CustomerDataProps = {
    customer: Customer;
};

export const CustomerData: FunctionComponent<CustomerDataProps> = ({
    customer,
}) => {
    return (
        <Grid2 spacing={3} container>
            <Grid2 size={{ sm: 4 }}>
                <CustomerDetailsCard customer={customer} />
            </Grid2>

            <Grid2 size={{ sm: 8 }}>
                <Grid2 spacing={3} container>
                    <Grid2 size={{ sm: 12 }}>
                        <NotesCard customer={customer} />
                    </Grid2>
                    <Grid2 size={{ sm: 6 }}>
                        <CustomerGroupsCard customer={customer} />
                    </Grid2>
                    <Grid2 size={{ sm: 6 }}>
                        <CustomerCreditCard customer={customer} />
                    </Grid2>
                </Grid2>
            </Grid2>
        </Grid2>
    );
};
